// DO NOT EDIT -- generated from fs/gcloud/dstore/protoauditstore/audit.proto

import * as protobuf from '../../../../google/protobuf';

/** The visibility of an Object. */
export enum Visibility {
  UNSET = 0,
  /** Only visible to the owning user */
  PRIVATE = 1,
  /** Visible to all members of the Org with permissions to view objects. */
  PUBLIC = 2
}

/** AuditMetadata encapsulates the common metadata we store for each versioned audit record of a configuration entity. */
export interface AuditMetadata {
  /** When this entity was last updated. */
  lastUpdated: protobuf.timestamp | null;
  /** Who made the last update to this entity. */
  lastUpdatedBy: string;
  /** When this entity was first created. */
  created: protobuf.timestamp | null;
  /** Who first created this entity. */
  createdBy: string;
  /** If this entity has been marked as "archived", which excludes it from basic queries. */
  archived: boolean;
  visibility: Visibility;
  /**
   * Opaque version. As an implementation detail, this is just last_updated as a
   * millisecond timestamp.
   */
  version: protobuf.int64;
  /**
   * A sequential version number. This may not be present or correct in all entities
   * until backfills are completed. Until that time, prefer version above.
   */
  sequentialVersion: protobuf.int64;
}
